import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { generateSearchFormItem } from "../../../../utils/helper";
import { SearchAccordion } from "../../../common";
import { defaultFilter, ISearchProps } from "./type";

const Search = ({ filter, setFilter, downloadData }: ISearchProps) => {
  const { t } = useTranslation();
  const T = (name: string) => {
    return t(`common.${name}`);
  };

  return (
    <SearchAccordion>
      <Formik
        initialValues={filter}
        onSubmit={(values, { setSubmitting }) => {
          setFilter({ ...values, pages: 0 });
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateSearchFormItem(
              form,
              [
                {
                  type: "time",
                  name: "time",
                  label: "Time",
                },
                {
                  type: "text",
                  name: "title",
                  label: "Title",
                },
              ],
              defaultFilter(),
              T,
              downloadData,
              "Event"
            )}
          </Form>
        )}
      </Formik>
    </SearchAccordion>
  );
};

export default Search;
